import sessionReader from '../store/readHelpers/SessionReader';

const chatIntegrationService = {
    getChatBoxHost() {
        return window.chatClientBoxHost;
    },

    getToken() {
        return sessionReader.getSessionInfoValue('chatBoxAppToken');
    },
};

export default chatIntegrationService;
